import * as types from './actionTypes';
import {apiPost, apiPut, apiRequest} from '../utils/request';
import {toastr} from 'react-redux-toastr';
import { addFiltersToUrl, getErrorMessage, mustBeArray, requestHasError } from '../utils/lib';
import { getClientRequestActionMessage } from '../utils';
import { CLIENT_REQUEST_APPROVED_ID, CLIENT_REQUEST_REJECTED_ID } from '../constants';

export function listPendingRequestsSuccess({items}){
  return {type: types.LIST_PENDING_REQUESTS, items};
}

export function clearPendingRequestsSuccess(){
  return {type: types.CLEAR_PENDING_REQUESTS, items: []};
}

export function getPendingRequestsCountSuccess({items}){
  return {type: types.GET_PENDING_REQUESTS_COUNT, items};
}

export function clearPendingRequestsCountSuccess(){
  return {type: types.CLEAR_PENDING_REQUESTS_COUNT, items: 0};
}

export function listPendingRequests({getTotal=false, filters={}}) {
  return function (dispatch) {
    const url = addFiltersToUrl({url: "/api/clientrequests", filters});
    return apiRequest(url)
      .then(x => {
        if (requestHasError({x})) {
          if(getTotal){
            return dispatch(clearPendingRequestsCountSuccess);
          }
          toastr.error(`Error: ${getErrorMessage({x})}`);
          dispatch(clearPendingRequestsSuccess());
        } else {
          if(getTotal){
            const total = mustBeArray(x && x.data).filter(o => ![CLIENT_REQUEST_APPROVED_ID, CLIENT_REQUEST_REJECTED_ID].includes(o.requestStatusId)).length;
            return dispatch(getPendingRequestsCountSuccess({items: total}));
          }
          dispatch(listPendingRequestsSuccess({items: mustBeArray(x && x.data)}));
        }
        return x;
      });
  };
}

export function getClientRequestDetail({id}) {
  return function (dispatch) {
    return apiRequest(`/api/clientrequests/view?id=${id}`)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Error: ${getErrorMessage({x})}`);
        }
        return x;
      });
  };
}

export function clearPendingRequests() {
  return function (dispatch) {
    return dispatch(clearPendingRequestsSuccess());
  };
}

export function updateClientRequest({payLoad, action}) {
  return function (dispatch) {
    toastr.info(getClientRequestActionMessage({action}));
    return apiPut(`/api/clientrequests?id=${payLoad && payLoad.id}`, payLoad)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(getErrorMessage({x}));
        }
        return x; 
      });
  };
}


// Get Request status
export function listRequestStatus() {
  return function (dispatch) {
    return apiRequest(`/api/clientrequests/request-status`)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Error: ${getErrorMessage({x})}`);
        } 
        return x;
      });
  };
}

export function listRequestTypes() {
  return function (dispatch) {
    return apiRequest(`/api/clientrequests/request-type`)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Error: ${getErrorMessage({x})}`);
        } 
        return x;
      });
  };
}

// Request new oil
export function saveNewOilRequest({payLoad}) {
  return function (dispatch) {
    return apiPost(`/api/clientrequests/new-oil`, payLoad)
      .then(x => {
        if (requestHasError({x})) {
          const defaultMessage = getErrorMessage({x});
          let message = defaultMessage === "Forbidden" ? "You do not have access to this resource. Please contact your system administrator." :  `Error: ${defaultMessage}`;
          toastr.error(message);
        }
        return x; 
      });
  };
}

export function saveNewDeliveryRequest({payLoad}) {
  return function (dispatch) {
    return apiPost(`/api/clientrequests/deliveries/new-request`, payLoad)
      .then(x => {
        if (requestHasError({x})) {
          const defaultMessage = getErrorMessage({x});
          let message = defaultMessage === "Forbidden" ? "You do not have access to this resource. Please contact your system administrator." :  `Error: ${defaultMessage}`;
          toastr.error(message);
        }
        return x; 
      });
  };
}